import Navbar from "layouts/Navbar";
import React from "react";
import { useRouteError } from "react-router-dom";
import Lottie from "lottie-react";
import errorAnimation from "../../assets/json/error.json";

const PageError = ({ not404 }) => {
  const error = useRouteError();

  // const handlerReload = (e) => {
  //   window.location.reload();
  // };

  const handlerGoBack = (e) => {
    window.history.back();
  };

  const handlerGoHome = (e) => {
    window.location.href = '/';
  };

  if (not404) {
    return (
      <>
        <Navbar />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "80vh" }}
        >
          <div className="text-center">
            <Lottie
              style={{ width: "50%", height: "50%", margin: "0 auto" }}
              animationData={errorAnimation}
              loop={true}
            />
            <h5 className="fw-bold">Internal Server Error</h5>
            <p>{error?.message || "Terjadi kesalahan pada server"}</p>
            <button
              className="btn btn-cta rounded-5 checkout-button mt-3"
              onClick={handlerGoBack}
            >
              Coba Lagi
            </button>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <Navbar />
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: "80vh" }}
        >
          <div className="text-center">
            <Lottie
              style={{ width: "30%", height: "30%", margin: "0 auto" }}
              animationData={errorAnimation}
              loop={true}
            />
            <h5 className="fw-bold">{error?.status || "404"}</h5>
            <p className="mb-3">{error?.statusText || "Halaman tidak ditemukan"}</p>
            <p className="text-muted mb-4">
              Halaman yang Anda cari tidak dapat ditemukan. Silakan kembali ke halaman utama.
            </p>
            <div className="d-flex gap-2 justify-content-center">
              <button
                className="btn btn-outline-secondary rounded-5"
                onClick={handlerGoBack}
              >
                Kembali
              </button>
              <button
                className="btn btn-cta rounded-5 checkout-button"
                onClick={handlerGoHome}
              >
                Halaman Utama
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default PageError;
